module.exports = __webpack_public_path__ + "static/media/backArrow.af8d6975.svg";